import {  login, onChangeAuth } from "page/auth/redux"
import { useRedux } from "redux/useRedux"

import { Form } from "antd";
import { useNavigate } from "react-router-dom";
import { AuthContext } from 'contexts/auth-context';
import { useContext } from 'react';


const LoginLogic = () => {
    const navigate = useNavigate()
    const [formLogin] = Form.useForm()
    const ctx = useContext(AuthContext);
    const { dispatch, authState } = useRedux()
    async function finish() {
        const result = await dispatch(login(formLogin))
        if (result) {
            dispatch(onChangeAuth("status","otp"))
            dispatch(onChangeAuth("fromPage","login"))
            dispatch(onChangeAuth("time",60))
            dispatch(onChangeAuth("phone",formLogin.getFieldsValue().username))
            
            // ctx.updateContext(result)
        }
    }
    return {
        formLogin, finish
    }

}
export default LoginLogic;